<template>
  <div class="form" :style="{ background: thisBgc }">
    <mu-card style="width: 100%; padding: 16px" raised>
      <mu-card-header>
        <div class="form-title">
          填写联系电话获取
          <b style="color: red; font-size: 26px">学费</b> 报价
        </div>
      </mu-card-header>
      <Form ref="formInline">
        <FormItem prop="user">
          <Input
            type="text"
            placeholder="您的姓名"
             v-model="username"
            size="large"
            color="red"
            clearable
          >
          </Input>
        </FormItem>
        <FormItem prop="password">
          <Input type="tel" placeholder="您的手机号" size="large"  v-model="mobile" clearable>
          </Input>
        </FormItem>
        <FormItem>
          <van-button
          :loading="loading"
           @click="show"
            color="linear-gradient(to right,#ee0a24,#ff6034)"
            size="small"
            style="border-radius: 4px; width: 100%"
          >
            {{ buttonWords }}
          </van-button>
           <Vcode :show="isShow" @success="send" @close="close" />
        </FormItem>
      </Form>
   
    </mu-card>
  </div>
</template>

<script>
import { Toast } from "vant";
import Vcode from "vue-puzzle-vcode";
export default {
  data() {
    return {
      thisBgc: this.bgc,
       username: "",
      mobile: "",
      loading: false,
      buttonWords: '立即查看学费',
      isShow: false
    };
  },
  watch: {
    mobile: "checkMobile"
  },
  components: {
    Vcode
  },
  props: {
    bgc: {
      type: String,
      default: "",
    },
  },
   methods: {
    checkMobile() {
      let m = this.mobile;
      let valid_rule = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
      if (m.length > 10) {
        if (!valid_rule.test(this.mobile)) {
          Toast.fail("手机号码错误");
          return false;
        }
      }
    },
    show() {
      this.buttonWords = "";
      this.loading = true;
      let valid_rule = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
      setTimeout(() => {
        this.loading = false;
        this.buttonWords = "立即查看学费";
      }, 1500);
      if (this.username == "" || this.mobile == "") {
        Toast.fail("请完整填写");
        return false;
      } else if (!valid_rule.test(this.mobile)) {
        Toast.fail("手机号码错误");
        return false;
      } else {
        this.isShow = true;
      }
    },
    close() {
      this.isShow = false;
    },
    send() {
      this.isShow = false;
      this.buttonWords = "";
      this.loading = true;
      this.$axios
        .get("http://api.cdomick.com/index.php/form/mianyanginsert", {
          params: {
            name: this.username,
            mobile: this.mobile,
            laiyuan: document.referrer,
            first: window.location.href
          }
        })
        .then(function(response) {
          console.log(response);
          if (response.data.code == 1) {
            Toast.success(response.data.msg);
            window._agl && window._agl.push(["track", ["success", { t: 3 }]]);
            // location.reload();
          } else {
            Toast.success("提交成功");
            window._agl && window._agl.push(["track", ["success", { t: 3 }]]);
            // location.reload();
          }
        })
        .catch(function(error) {
          console.log(error);
          Toast.success("成功");
          this.loading = false;
          this.buttonWords = "立即查看学费";
          window._agl && window._agl.push(["track", ["success", { t: 3 }]]);
          location.reload();
        });
    }
  }
};
</script>

<style lang="less" scoped>
::v-deep .ivu-input {
  border: 1px solid #f71614;
}
::v-deep .van-button--small {
  height: 32px;
  padding: 0 8px;
  font-size: 18px;
  font-weight: 600;
}
.form {
  width: 100%;
  padding: 16px;
  margin-top: -6px;

}
.form-title {
  font-size: 17px;
}
</style>